import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getFtpList } from "./action";

export const ftpPublishSliceEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
});

const initialState = ftpPublishSliceEntityAdapter.getInitialState({
  ftpPublishEventIds: [],
  count: 0,
});

export const ftpPublishSlice = createSlice({
  name: "ftpPublish",
  initialState: initialState,
  reducers: {
    storeFtpPublishEventId: (state, action) => {
      state.ftpPublishEventIds.push(action.payload);
    },
    removeFtpPublishEventId: (state, action) => {
      state.ftpPublishEventIds = state.ftpPublishEventIds.filter((eventId) => eventId !== action.payload);
    },
    clearFtpPublishList: (state) => {
      ftpPublishSliceEntityAdapter.removeAll(state);
      state.count = 0;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFtpList.fulfilled, (state, action) => {
      if (!action.payload.error) {
        const append = action.meta?.arg?.append || false;
        const list = action.payload.data.list || [];
        const totalRecords = action.payload.data.totalRecords || 0;

        if (append) {
          // Append/update entities to existing state
          ftpPublishSliceEntityAdapter.setMany(state, list);
          // Accumulate count when appending
          state.count += totalRecords;
        } else {
          // Replace all entities (clear and set)
          ftpPublishSliceEntityAdapter.setAll(state, list);
          state.count = totalRecords;
        }
      }
    });
  },
});

export const { storeFtpPublishEventId, removeFtpPublishEventId, clearFtpPublishList } = ftpPublishSlice.actions;

export default ftpPublishSlice.reducer;
